export const en = {
    "HTTP_запросы_к_Endpoint_URL": "HTTP requests to the Endpoint URL",
    "chart-error": "An error has occurred",
    "chart-error-no-data": "No data available",
    "chart-loading": "Loading",
    "chart-switch": "Display:",
    "chart-switch-num": "Number of errors",
    "chart-switch-rate": "Error rate",
    "date-day": "Day",
    "date-half-year": "Half-year",
    "date-hour": "Hour",
    "date-month": "Month",
    "date-week": "Week",
    "error": "An error has occurred",
    "error-no-public": "Monitoring is only available for published skills",
    "header": "Monitoring",
    "label-percentile": "Percentile:",
    "option-request-type": "Request type:",
    "option-source": "Source:",
    "Алиса": "Alice",
    "Время_ответа,_с": "Response time, s",
    "Все_источники": "All sources",
    "Все_типы": "All types",
    "Запрос_в_навык": "Request to skill",
    "Запросы_в_навык": "Requests to the skill",
    "Изменение_состояния_у_устройств_(action)": "Changing the state of devices (action)",
    "Информация_о_состояниях_устройств_пользователя_(query)": "Information about the states of the user's devices (query)",
    "Информация_об_устройствах_пользователя_(discovery)": "Information about the user's devices (discovery)",
    "Оповещение_о_разъединении_аккаунтов_(unlink)": "Notification about disconnecting accounts (unlink)",
    "Ошибки": "Errors",
    "Ошибки_обновления_списка_устройств": "Errors updating the device list",
    "Ошибки_обращения_к_устройствам": "Errors in accessing devices",
    "Пользовательские_запросы": "User Requests",
    "Приложение_Яндекс_(UI)": "Yandex app (UI)",
    "Режим_тестирования": "Testing mode",
    "Тайминги": "Timings"
} as const;
export const ru = {
    "HTTP_запросы_к_Endpoint_URL": "HTTP запросы к Endpoint URL",
    "chart-error": "Произошла ошибка",
    "chart-error-no-data": "Нет данных",
    "chart-loading": "Загрузка",
    "chart-switch": "Отображать:",
    "chart-switch-num": "Кол-во ошибок",
    "chart-switch-rate": "Процент ошибок",
    "date-day": "Сутки",
    "date-half-year": "Полгода",
    "date-hour": "Час",
    "date-month": "Месяц",
    "date-week": "Неделя",
    "error": "Произошла ошибка",
    "error-no-public": "Мониторинг доступен только для опубликованных навыков",
    "header": "Мониторинг",
    "label-percentile": "Перцентиль:",
    "option-request-type": "Тип запроса:",
    "option-source": "Источник:",
    "Алиса": "Алиса",
    "Время_ответа,_с": "Время ответа, с",
    "Все_источники": "Все источники",
    "Все_типы": "Все типы",
    "Запрос_в_навык": "Запрос в навык",
    "Запросы_в_навык": "Запросы в навык",
    "Изменение_состояния_у_устройств_(action)": "Изменение состояния у устройств (action)",
    "Информация_о_состояниях_устройств_пользователя_(query)": "Информация о состояниях устройств пользователя (query)",
    "Информация_об_устройствах_пользователя_(discovery)": "Информация об устройствах пользователя (discovery)",
    "Оповещение_о_разъединении_аккаунтов_(unlink)": "Оповещение о разъединении аккаунтов (unlink)",
    "Ошибки": "Ошибки",
    "Ошибки_обновления_списка_устройств": "Ошибки обновления списка устройств",
    "Ошибки_обращения_к_устройствам": "Ошибки обращения к устройствам",
    "Пользовательские_запросы": "Пользовательские запросы",
    "Приложение_Яндекс_(UI)": "Приложение Яндекс (UI)",
    "Режим_тестирования": "Режим тестирования",
    "Тайминги": "Тайминги"
} as const;